<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { Data } from '~~/server/api/insurance/additional/insurance/[slug]'

export interface PagesAdditionalInsuranceDetailProps {
    data: Data
}

const props = defineProps<PagesAdditionalInsuranceDetailProps>()
const { $t } = useNuxtApp()

const productsTitle = $t('Môže byť súčasťou poistenia:')
</script>
<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-10">
      <Box
        :decor="false"
        class="box-shadow-1 rounded mb-10"
        color="white"
        padding="p-2 p-md-8"
      >
        <section
          v-if="props.data.description"
          class="mb-10"
        >
          <h2 class="delta mb-5">
            {{ $t('Popis pripoistenia') }}
          </h2>
          <Typo>
            <div v-html="props.data.description" />
          </Typo>
        </section>
        <section v-if="props.data.products.length > 0">
          <Tracker
            :data="{
              title: productsTitle,
            }"
          >
            <h2 class="delta mb-8">
              {{ productsTitle }}
            </h2>
            <div class="row justify-content-start g-2">
              <template v-if="!props.data.life_insurance">
                <div
                  v-for="(product, index) in props.data.products"
                  :key="`bici-${index}`"
                  class="translate-y-hover-wrapper col-12 col-md-6 col-lg-4 mt-2 mt-md-6"
                >
                  <ProductBoxSimple
                    class="box-shadow-1"
                    :title="product.title"
                    :to="useNamedRoutes({
                      name: 'insurance-detail',
                      params: {
                        id: product.slug,
                        category:
                          product.category,
                      },
                    })"
                  />
                </div>
              </template>

              <template v-else>
                <div
                  v-for="(product, index) in props.data.products"
                  :key="`bici-${index}`"
                  class="col-12 col-md-4 col-lg-3"
                >
                  <article
                    class="rounded bg-white px-3 py-6 px-md-4 h-100 box-shadow-1"
                  >
                    <h3 class="zeta mb-2">
                      <VNuxtLink
                        :to="
                          useNamedRoutes({
                            name: 'insurance-detail',
                            params: {
                              id: product.slug,
                              category:
                                product.category,
                            },
                          })
                        "
                        :label="product.title"
                        class="text-black text-decoration-underline"
                      >
                        {{ product.title }}
                      </VNuxtLink>
                    </h3>
                    <ul class="d-flex flex-column gap-3">
                      <li
                        v-for="(
                          item, index2
                        ) in product.specification"
                        :key="`paidi-${index2}`"
                        class="d-flex align-items-center fs-small"
                      >
                        <img
                          v-if="item.icon"
                          :src="item.icon.path"
                          width="20"
                          height="20"
                          class="d-block me-3"
                          alt=""
                        >
                        {{ item.title }}
                      </li>
                    </ul>
                  </article>
                </div>
              </template>
            </div>
          </Tracker>
        </section>
      </Box>
    </div>
  </div>
</template>
